import type { CouponRecord } from '@navio/nsdk';

export type CouponSourceKind = 'standalone' | 'campaign' | 'referral';

export const couponSourceKind = (coupon: CouponRecord): CouponSourceKind => {
  if (coupon.campaign) {
    return 'campaign';
  }
  if (coupon.referral) {
    return 'referral';
  }
  return 'standalone';
};

export const COUPON_SOURCE_LABEL: Record<CouponSourceKind, string> = {
  standalone: 'Standalone',
  campaign: 'Campaign',
  referral: 'Referral'
};

export const couponSourceLabel = (coupon: CouponRecord): string => COUPON_SOURCE_LABEL[couponSourceKind(coupon)];

export const couponSourceSecondary = (coupon: CouponRecord): string | null => {
  if (coupon.campaign?.name) {
    return coupon.campaign.name;
  }
  if (coupon.referral?.slug) {
    return coupon.referral.slug;
  }
  return null;
};
